import { render, staticRenderFns } from "./payroll-detail.vue?vue&type=template&id=1e1c37da&scoped=true"
import script from "./payroll-detail.vue?vue&type=script&lang=js"
export * from "./payroll-detail.vue?vue&type=script&lang=js"
import style0 from "./payroll-detail.vue?vue&type=style&index=0&id=1e1c37da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1c37da",
  null
  
)

export default component.exports